<template>
  <div class="cms-tool" :class="{ 'pb-2 px-2': this.edit && type !== 'image'}">
    <div class="align-center tool-header d-flex flex-row">
      <div @click="highlightInPreview" class="align-center flex-row d-flex flex-grow-1 flex-shrink-1 text-truncate tool-label">
        <v-icon>mdi-drag-vertical</v-icon>
        <v-icon class="ma-2 tool-icon">{{this.icon}}</v-icon>
        <div class="align-center text-truncate flex-shrink-1 long-and-truncated " v-if="!this.edit">
          <div class="text-header flex-shrink-1" v-if="type == 'product_image'">{{$t('cmstool_product_picture_auto')}}</div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'product_name'">{{$t('cmstool_product_name_auto')}}</div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'product_description'">{{$t('cmstool_product_description_auto')}}</div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'photo_auth'">{{$t('cmstool_authentication_app')}}</div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'scan_result'">{{$t('cmstool_authentication_result_auto')}}</div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'elabel'">{{$t('cmstool_elabel_button')}}</div>
          <div class="text-header flex-shrink-1" v-else-if="type && type.startsWith('elabel_')">{{ $t(`cmstool_${type}`) }}</div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'text' || type == 'consume' || type == 'large_text' || type == 'divider'" v-html="getFirstLine(toolData.content[lang])"></div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'iframe'">{{toolData.url[lang]}}</div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'image' && !isDisplayableImage(toolData.src[lang])">{{toolData.src[lang]}}</div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'image' && isDisplayableImage(toolData.src[lang])"></div>
          <div class="text-header flex-shrink-1" v-else-if="type == 'file'">{{fileToolLabel}}</div>
          <div class="text-header flex-shrink-1" v-else>{{toolData.content && toolData.content[lang] && toolData.content[lang].length ? toolData.content[lang] : $t('edit_me')}} 👉</div>
        </div>
        <img class="image-header" :src="toolData.src[lang]" v-if="(type == 'image' || type == 'gallery') && !this.edit && isDisplayableImage(toolData.src[lang])"/>
      </div>

      <div class="tool-btn-ctn flex-shrink-0">
        <div v-if="!this.edit" class="d-flex flex-row">
          <div v-if="type === 'product_name' || type === 'product_image' || type === 'product_description' || type === 'scan_result' || (type && type.startsWith('elabel_'))">
            <!-- <product-image v-if="type === 'product_image'"></product-image> -->
            <scan-result v-if="type === 'scan_result'"></scan-result>
          </div>
          <gallery-edit v-else-if="type == 'gallery'" :image="toolData.src[lang]" @image-selected="onImageUpload"></gallery-edit>
          <image-cropper v-else-if="type == 'image'" :input-key="`image-cropper-${tabId}-${toolKey}`" @image-upload="onImageUpload" :tab-id="tabId" :icon="true"></image-cropper>

          <v-btn v-else @click="toggleEditMode" color="primary" icon>
            <v-icon>$edit</v-icon>
          </v-btn>
          <v-tooltip top v-if="type === 'image' && isAllowed('gallery_view')">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="primary" @click="handleSTGalleryBtnClick" >
                <v-icon>mdi-image-outline</v-icon>
              </v-btn>
            </template>
            <span>{{$t('cmstool_select_image_gallery')}}</span>
          </v-tooltip>

          <v-tooltip top v-if="type === 'file' && isAllowed('gallery_view')">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="primary" @click="handlePdfGalleryBtnClick" >
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-btn>
            </template>
            <span>{{$t('cmstool_select_pdf_gallery')}}</span>
          </v-tooltip>

          <v-tooltip top v-if="type == 'image' && isAvailable('editor:tabs:tools:image:link')">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on"  @click="toggleEditMode" color="primary" icon>
                <v-icon>mdi-link</v-icon>
              </v-btn>
            </template>
            <span>{{$t('cmstool_add_picture_with_link')}}</span>
          </v-tooltip>
          <v-tooltip top v-if="type && type.startsWith('elabel_') && isAvailable('editor:tabs:tools:css')">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="openStylesModal(true)" color="accent" icon>
                <v-icon>mdi-code-json</v-icon>
              </v-btn>
            </template>
            <span>{{$t('css_editor')}}</span>
          </v-tooltip>
          <v-btn @click="removeModal = true" icon>
            <v-icon>$remove</v-icon>
          </v-btn>
        </div>
        <div v-else>
          <v-tooltip top v-if="type === 'file' && isAllowed('gallery_view')">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="primary" @click="handlePdfGalleryBtnClick" >
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-btn>
            </template>
            <span>{{$t('cmstool_select_pdf_gallery')}}</span>
          </v-tooltip>
          <v-tooltip top v-if="isAvailable('editor:tabs:tools:css')">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="openStylesModal()" color="accent" icon>
                <v-icon>mdi-code-json</v-icon>
              </v-btn>
            </template>
            <span>{{$t('css_editor')}}</span>
          </v-tooltip>
          <v-btn @click="save" color="accent" icon>
            <v-icon>$check</v-icon>
          </v-btn>
          <v-btn @click="cancel" color="accent" icon>
            <v-icon>$cancel</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <!-- <div class="long-and-truncated" v-if="type == 'text' || type == 'consume'" v-html="getFirstLine(toolData.content[lang])"></div> -->
    <div v-if="this.edit" class="edit-box" :key="editBoxKey">
      <text-edit :ref="`text-edit-${toolKey}-${tabId}`" v-if="type === 'text' && toolData.content" :content="toolData.content[lang]" :styles="toolStyles"></text-edit>
      <text-edit :ref="`large-text-edit-${toolKey}-${tabId}`" v-if="type === 'large_text' && toolData.content" :content="toolData.content[lang]" :styles="toolStyles"></text-edit>
      <photo-auth-edit :ref="`photo-auth-edit-${toolKey}-${tabId}`" v-if="type === 'photo_auth'" :button="toolData.button[lang]" ></photo-auth-edit>
      <image-edit :ref="`image-edit-${toolKey}-${tabId}`" v-if="type == 'image'" :src.sync="toolData.src[lang]"></image-edit>
      <button-edit :ref="`button-edit-${toolKey}-${tabId}`" v-if="type === 'button' && toolData.content" :content="toolData.content[lang]" :url="toolData.url[lang]" :styles="toolStyles"></button-edit>
      <file-edit :ref="`file-edit-${toolKey}-${tabId}`" v-if="type === 'file' && toolData.content" :content="toolData.content[lang]" :url="toolData.url[lang]" :styles="toolStyles"></file-edit>
      <divider-edit :ref="`divider-edit-${toolKey}-${tabId}`" v-if="type === 'divider' && toolData.content" :content="toolData.content[lang]" :styles="toolStyles"></divider-edit>
      <typeform-edit :ref="`typeform-edit-${toolKey}-${tabId}`" v-if="type === 'typeform' && toolData.content" :content="toolData.content[lang]" :mode="toolData.mode" :url="toolData.url[lang]" :styles="toolStyles"></typeform-edit>
      <social-edit :ref="`social-edit-${toolKey}-${tabId}`" v-if="type === 'social' && toolData.content" :content="toolData.content[lang]" :url="toolData.url[lang]" :icon="toolData.icon" :styles="toolStyles"></social-edit>
      <video-edit :ref="`video-edit-${toolKey}-${tabId}`" v-if="type === 'video' && toolData.content" :content.sync="toolData.content[lang]"></video-edit>
      <iframe-edit v-if="type === 'iframe'" :url.sync="toolData.url[lang]" :height.sync="toolData.height[lang]"></iframe-edit>
      <consume-edit :ref="`consume-edit-${toolKey}-${tabId}`" :content.sync="toolData.content[lang]" :consumed.sync="toolData.consumed[lang]" :button.sync="toolData.button[lang]" :mode.sync="toolData.mode" :styles="toolStyles" v-if="type === 'consume'"></consume-edit>
      <elabel-edit :ref="`elabel-edit-${toolKey}-${tabId}`" v-if="type === 'elabel' && toolData.content" :content.sync="toolData.content[lang]" :styles="toolStyles"></elabel-edit>
    </div>

    <v-dialog width="500" v-model="stylesModal">
      <v-card>
        <v-card-title class="headline">{{$t('cmstool_update_widget_css')}}</v-card-title>
        <vue-json-editor ref="jsonEditor" class="fullscreen" v-model="toolStyles" mode="code" :expandedOnStart="true"></vue-json-editor>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelStylesModal">{{$t('cancel')}}</v-btn>
          <v-btn text color="primary" @click="updateStyle">{{$t('save')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="500" v-model="removeModal">
      <v-card>
        <v-card-title class="headline">{{$t('delete_confirmation')}}</v-card-title>

        <v-card-text>
          <div class="my-5">
            <div>{{$t('cmstool_remove_item_question')}}</div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="removeModal = false">{{$t('cancel')}}</v-btn>
          <v-btn text color="red" @click="remove">{{$t('remove')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <select-image-dialog
      :display-select-image-dialog="displaySTGalleryDialog"
      @update:displaySelectImageDialog="closeSTGalleryDialog"
      @gallery-selected="handleSTGallerySelected"
      :app-tags="['stc-editor-image']"
      :isAllowedEdit="isAllowed('gallery_edit')"
    ></select-image-dialog>
    <select-image-dialog
      file-type="pdf"
      :display-select-image-dialog="displayPdfGalleryDialog"
      @update:displaySelectImageDialog="closePdfGalleryDialog"
      @gallery-selected="handlePdfGallerySelected"
      @gallery-item-selected="handlePdfGalleryItemSelected"
      :isAllowedEdit="isAllowed('gallery_edit')"
    ></select-image-dialog>
  </div>
</template>

<script>
import ButtonEdit from '@/components/editor/ButtonEdit'
import ConsumeEdit from '@/components/editor/ConsumeEdit'
import DividerEdit from '@/components/editor/DividerEdit'
import GalleryEdit from '@/components/editor/GalleryEdit'
import IframeEdit from '@/components/editor/IframeEdit'
import ImageEdit from '@/components/editor/ImageEdit'
import PhotoAuthEdit from '@/components/editor/PhotoAuthEdit'
import ScanResult from '@/components/editor/ScanResult'
import SocialEdit from '@/components/editor/SocialEdit'
import TextEdit from '@/components/editor/TextEdit'
import TypeformEdit from '@/components/editor/TypeformEdit'
import VideoEdit from '@/components/editor/VideoEdit'
import ElabelEdit from '@/components/editor/ElabelEdit'
import ImageCropper from '@/components/utils/ImageCropper'
import DOMPurify from 'dompurify'
import { convertToSTCString } from '@/utils/configHelpers'
import { SelectImageDialog } from '@scantrust/st-gallery'
import FileEdit from '@/components/editor/FileEdit'
import amplitude from 'amplitude-js'
import vueJsonEditor from 'vue-json-editor'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'cms-tool',
  props: ['type', 'icon', 'data', 'lang', 'tool-key', 'tab-id', 'styles'],
  computed: {
    ...mapGetters(['defaultLanguage', 'isEditDisabled', 'isAvailable', 'isAllowed']),
    fileToolLabel () {
      const label = this.toolData.content && this.toolData.content[this.lang]
      return label && label.length ? label : `${this.$t('edit_me')} 👉`
    }
  },
  components: {
    'text-edit': TextEdit,
    'button-edit': ButtonEdit,
    'divider-edit': DividerEdit,
    'typeform-edit': TypeformEdit,
    'social-edit': SocialEdit,
    'image-edit': ImageEdit,
    'image-cropper': ImageCropper,
    'iframe-edit': IframeEdit,
    'video-edit': VideoEdit,
    'consume-edit': ConsumeEdit,
    'gallery-edit': GalleryEdit,
    'photo-auth-edit': PhotoAuthEdit,
    'elabel-edit': ElabelEdit,
    ScanResult,
    vueJsonEditor,
    SelectImageDialog,
    'file-edit': FileEdit
  },
  methods: {
    ...mapMutations({
      enterEditMode: 'ENTER_EDIT_MODE',
      leaveEditMode: 'LEAVE_EDIT_MODE'
    }),

    highlightInPreview () {
      // TODO magic
    },

    isDisplayableImage (string) {
      if (string && string.indexOf('{') > -1) {
        return false
      }
      return true
    },

    openStylesModal (directSave = false) {
      this.toolStylesBackup = JSON.parse(JSON.stringify(this.toolStyles))
      this.stylesDirectSave = directSave
      this.stylesModal = true
    },

    updateStyle () {
      // If user clears the JSON editor completely, wipe the styles
      const editorText = this.$refs.jsonEditor && this.$refs.jsonEditor.editor ? this.$refs.jsonEditor.editor.getText() : null
      if (editorText !== null && editorText.trim() === '') {
        this.toolStyles = {}
      }

      if (this.stylesDirectSave) {
        // Triggered from a widget that has no edit-mode (e.g. elabel widgets): update immediately since there's no main save() coming.
        const styles = this.toolStyles && this.toolStyles.clear ? {} : this.toolStyles
        this.$store.dispatch('overrideComponentStyle', { toolKey: this.toolKey, tabId: this.tabId, styles })
        this.stylesDirectSave = false
      }
      this.editBoxKey++ // remounting the edit box makes it so that when the user saves changes in the CSS JSON editor, the visual controls (font size counter, color swatches, alignment buttons) update to reflect the new values
      this.stylesModal = false
    },

    cancelStylesModal () {
      this.toolStyles = JSON.parse(JSON.stringify(this.toolStylesBackup))
      this.stylesDirectSave = false
      this.stylesModal = false
    },

    toggleEditMode () {
      if (this.edit) {
        this.cancel()
      } else {
        if (this.type === 'gallery') {
          return
        }
        amplitude.getInstance().logEvent('Edit Widget', { type: this.type })
        this.syncToolData()
        this.enterEditMode()
      }
      this.edit = !this.edit
    },

    onImageUpload (url) {
      if (typeof this.toolData.src === 'string') {
        this.toolData.src = {}
      }
      this.toolData.src[this.lang] = url
      this.save()
    },
    handleSTGallerySelected (url) {
      this.toolData.src[this.lang] = url
      this.save()
    },
    fileEditRef () {
      return this.$refs[`file-edit-${this.toolKey}-${this.tabId}`]
    },
    handlePdfGallerySelected (url) {
      const fileEdit = this.fileEditRef()
      if (this.edit && fileEdit) {
        fileEdit.setUrl(url)
        return
      }
      this.toolData.url[this.lang] = url
      this.save()
    },
    handlePdfGalleryItemSelected (item) {
      if (!item || !item.name) return
      const fileEdit = this.fileEditRef()
      const current = this.edit && fileEdit
        ? fileEdit.form.content
        : this.toolData.content[this.lang]
      if (current && current !== this.autoFileLabel) return
      this.autoFileLabel = item.name
      if (this.edit && fileEdit) {
        fileEdit.setContent(item.name)
        return
      }
      this.toolData.content[this.lang] = item.name
      this.save()
    },

    getFirstLine (html) {
      var element = document.createElement('span')

      if (!html || typeof html !== 'string') {
        element.innerHTML = '<span>Edit me!</span>'
      } else {
        element.innerHTML = html
      }
      return element.textContent || element.innerText
    },

    remove () {
      amplitude.getInstance().logEvent('Remove Widget', { type: this.type })
      this.$store.dispatch('removeTabBody', { toolKey: this.toolKey, tabId: this.tabId })
      this.removeModal = true
    },

    convertToEmbedUrl (url) {
      if (url.indexOf('/watch?v=') > -1) {
        const videoId = url.split('/watch?v=')[1]
        return 'https://www.youtube.com/embed/' + videoId
      }
      return url
    },

    save () {
      // save styles

      if (this.type === 'text' && this.$refs[`text-edit-${this.toolKey}-${this.tabId}`]) {
        console.log('sanitized content', this.sanitizeHTML(convertToSTCString(this.$refs[`text-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content)))
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(convertToSTCString(this.$refs[`text-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content))
        this.toolStyles = this.$refs[`text-edit-${this.toolKey}-${this.tabId}`].localStyles
      } else if (this.type === 'large_text' && this.$refs[`large-text-edit-${this.toolKey}-${this.tabId}`]) {
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(convertToSTCString(this.$refs[`large-text-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content))
        this.toolStyles = this.$refs[`large-text-edit-${this.toolKey}-${this.tabId}`].localStyles
      } else if (this.type === 'button' && this.$refs[`button-edit-${this.toolKey}-${this.tabId}`] && this.$refs[`button-edit-${this.toolKey}-${this.tabId}`].editorContentJson) {
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(this.$refs[`button-edit-${this.toolKey}-${this.tabId}`].form.content)
        this.toolData.url[this.defaultLanguage] = convertToSTCString(this.$refs[`button-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content, true)
        this.toolStyles = this.$refs[`button-edit-${this.toolKey}-${this.tabId}`].localStyles
      } else if (this.type === 'file' && this.$refs[`file-edit-${this.toolKey}-${this.tabId}`] && this.$refs[`file-edit-${this.toolKey}-${this.tabId}`].editorContentJson) {
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(this.$refs[`file-edit-${this.toolKey}-${this.tabId}`].form.content)
        this.toolData.url[this.defaultLanguage] = convertToSTCString(this.$refs[`file-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content, true)
        this.toolStyles = this.$refs[`file-edit-${this.toolKey}-${this.tabId}`].localStyles
      } else if (this.type === 'image' && this.$refs[`image-edit-${this.toolKey}-${this.tabId}`] && this.$refs[`image-edit-${this.toolKey}-${this.tabId}`].editorContentJson) {
        this.toolData.src[this.defaultLanguage] = this.sanitizeHTML(convertToSTCString(this.$refs[`image-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content, true))
      } else if (this.type === 'consume' && this.$refs[`consume-edit-${this.toolKey}-${this.tabId}`]) {
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(convertToSTCString(this.$refs[`consume-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content))
        this.toolData.consumed[this.defaultLanguage] = this.sanitizeHTML(convertToSTCString(this.$refs[`consume-edit-${this.toolKey}-${this.tabId}`].editorConsumedContentJson.content))
        this.toolStyles = this.$refs[`consume-edit-${this.toolKey}-${this.tabId}`].localStyles
      } else if (this.type === 'social' && this.$refs[`social-edit-${this.toolKey}-${this.tabId}`]) {
        this.toolData.icon = this.$refs[`social-edit-${this.toolKey}-${this.tabId}`].form.icon
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(this.$refs[`social-edit-${this.toolKey}-${this.tabId}`].form.content)
        this.toolData.url[this.defaultLanguage] = convertToSTCString(this.$refs[`social-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content, true)
      } else if (this.type === 'typeform') {
        this.toolData.url[this.defaultLanguage] = convertToSTCString(this.$refs[`typeform-edit-${this.toolKey}-${this.tabId}`].urlContentJson.content, true)
        // this.toolData.url[this.defaultLanguage] = this.$refs[`typeform-edit-${this.toolKey}-${this.tabId}`].form.url
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(this.$refs[`typeform-edit-${this.toolKey}-${this.tabId}`].form.content)
        // GREATEST MYSTERY EVER, if you do it on a single line it crashes for some reason...
        // this.toolData.mode = this.$refs[`typeform-edit-${this.toolkey}-${this.tabId}`].form.mode
        // But with 2 lines it works fine...
        const mode = this.$refs[`typeform-edit-${this.toolKey}-${this.tabId}`].form.mode
        this.toolData.mode = mode
        this.toolStyles = this.$refs[`typeform-edit-${this.toolKey}-${this.tabId}`].localStyles
      } else if (this.type === 'divider' && this.$refs[`divider-edit-${this.toolKey}-${this.tabId}`]) {
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(convertToSTCString(this.$refs[`divider-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content, true))
        this.toolStyles = this.$refs[`divider-edit-${this.toolKey}-${this.tabId}`].localStyles
      } else if (this.type === 'video' && this.$refs[`video-edit-${this.toolKey}-${this.tabId}`]) {
        this.toolData.content[this.defaultLanguage] = this.convertToEmbedUrl(convertToSTCString(this.$refs[`video-edit-${this.toolKey}-${this.tabId}`].editorContentJson.content, true))
      } else if (this.type === 'photo_auth') {
        this.toolData.button[this.defaultLanguage] = this.sanitizeHTML(this.$refs[`photo-auth-edit-${this.toolKey}-${this.tabId}`].form.button)
      } else if (this.type === 'elabel' && this.$refs[`elabel-edit-${this.toolKey}-${this.tabId}`]) {
        this.toolData.content[this.defaultLanguage] = this.sanitizeHTML(this.$refs[`elabel-edit-${this.toolKey}-${this.tabId}`].form.content)
        this.toolStyles = this.$refs[`elabel-edit-${this.toolKey}-${this.tabId}`].localStyles
      }

      amplitude.getInstance().logEvent('Save Widget', { type: this.type })
      this.$store.dispatch('updateTabBodyContent', { toolKey: this.toolKey, data: this.toolData, tabId: this.tabId })

      const styles = this.toolStyles && this.toolStyles.clear ? {} : this.toolStyles
      this.$store.dispatch('overrideComponentStyle', { toolKey: this.toolKey, tabId: this.tabId, styles })
      this.$nextTick(() => {
        this.leaveEditMode()
        this.edit = false
      })
    },

    getExistingValue (obj) {
      for (const value of Object.values(obj)) {
        if (value.length) {
          return value
        }
      }
      return ''
    },

    cancel () {
      this.toolStyles = this.styles ? JSON.parse(JSON.stringify(this.styles)) : {}
      this.leaveEditMode()
      this.edit = false
    },

    sanitizeHTML (content) {
      return DOMPurify.sanitize(content)
    },
    handleSTGalleryBtnClick () {
      this.displaySTGalleryDialog = true
    },
    closeSTGalleryDialog () {
      this.displaySTGalleryDialog = false
    },
    handlePdfGalleryBtnClick () {
      this.displayPdfGalleryDialog = true
    },
    closePdfGalleryDialog () {
      this.displayPdfGalleryDialog = false
    },

    syncToolData () {
      this.toolData = JSON.parse(JSON.stringify(this.data))
      if (this.toolData.content && !this.toolData.content[this.lang]) {
        this.toolData.content[this.lang] = this.toolData.content[this.defaultLanguage] ? this.toolData.content[this.defaultLanguage] : this.getExistingValue(this.toolData.content)
      }
    }
  },
  data () {
    return {
      edit: false,
      toolData: {},
      removeModal: false,
      stylesModal: false,
      stylesDirectSave: false,
      displaySTGalleryDialog: false,
      displayPdfGalleryDialog: false,
      autoFileLabel: '',
      toolStylesBackup: {},
      editBoxKey: 0
    }
  },

  watch: {
    lang (newVal, oldVal) {
      if (newVal === oldVal || this.edit) return
      this.syncToolData()
    },
    styles (newVal) {
      this.toolStyles = newVal ? JSON.parse(JSON.stringify(newVal)) : {}
    }
  },

  created () {
    this.toolStyles = this.styles ? JSON.parse(JSON.stringify(this.styles)) : {}
    this.syncToolData()
  }
}

</script>

<style lang="sass" scoped>

.edit-box
  background: white

.tool-icon
  min-width: 24px

.text-header
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  ::v-deep p
    margin: 0px !important

.image-header
  max-height: 60px

</style>
